import { SupernovaException } from "../../utils";
import { WorkspaceRole } from "../../workspace";
import { z } from "zod";
export const DesignSystemRole = z.enum([
    WorkspaceRole.Admin,
    WorkspaceRole.Contributor,
    WorkspaceRole.Creator,
    WorkspaceRole.Viewer,
]);
export function workspaceRoleToDesignSystemRole(role) {
    switch (role) {
        case "Owner":
        case "Admin":
            return "Admin";
        case "Creator":
            return "Creator";
        case "Contributor":
            return "Contributor";
        case "Billing":
        case "Viewer":
            return "Viewer";
        case "Guest":
            throw SupernovaException.shouldNotHappen(`Illegal role ${role}`);
    }
}
